module.exports = __webpack_public_path__ + "8c2e43191823f43284168d64f51a62d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/ProductionShiftReportSection4.png
// module id = 316
// module chunks = 0